import logo from './logo.svg';
import './App.css';
import ReportIssue from './pages/ReportIssue/ReportIssue';

function App() {
  return (
    <div className="App">
      <ReportIssue />
    </div>
  );
}

export default App;
